import { render, staticRenderFns } from "./AdminUsers.vue?vue&type=template&id=5bde34c6&scoped=true&"
import script from "./AdminUsers.vue?vue&type=script&lang=js&"
export * from "./AdminUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bde34c6",
  null
  
)

export default component.exports